const ADD_TODO = "ADD_TODO";
const DELETE_TODO = "DELETE_TODO";
const TOGGLE_COMPLETED = "TOGGLE_COMPLETED";
const TOGGLE_ALL_COMPLETED = "TOGGLE_ALL_COMPLETED";
const EDIT_CONTENT = "EDIT_CONTENT";
const CLEAR_COMPLETED = "CLEAR_COMPLETED";
const CHANGE_FILTER = "CHANGE_FILTER";
const TODOS_STORAGE_KEY = "TODOS_STORAGE_KEY";

export {
  ADD_TODO,
  DELETE_TODO,
  TOGGLE_COMPLETED,
  EDIT_CONTENT,
  TOGGLE_ALL_COMPLETED,
  CLEAR_COMPLETED,
  CHANGE_FILTER,
  TODOS_STORAGE_KEY,
};
